export const ApprovalInFlightEditRule = {
  /** Only approvers can edit */
  Approvers: 'approvers',
  /** Everyone who has access can edit */
  Everyone: 'everyone',
  /** No one can edit */
  Noone: 'noone',
} as const;

export type ApprovalInFlightEditRule =
  (typeof ApprovalInFlightEditRule)[keyof typeof ApprovalInFlightEditRule];
